import { Box, styled } from '@mui/material';

export const StyledAuthFormContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
